import angular from 'angular';
import routing from './global_event.routes';
import moment from 'angular-moment';

import GlobalEventService from '../../../components/api/global_event/global_event.service';

import './global_event.css';

export class OemGlobalEventController {
  /*@ngInject*/
  constructor(moment, $mdDialog, $scope, GlobalEventService) {
    this.moment = moment;
    this.$mdDialog = $mdDialog;
    this.GlobalEventService = GlobalEventService;

    this.globalEvents = [];
    this.occurred_at = this.moment().toDate();
    this.text = '';

    $scope.$watch('$ctrl.text', () => {
      if (!this.text) {
        this.text = '';
      }
    });

    /*@ngInject*/
    this.dialogController = ($scope, $mdDialog, text, occurred_at) => {
      $scope.text = text;
      $scope.occurred_at = occurred_at;

      $scope.closeDialog = function () {
        $mdDialog.cancel();
      };

      $scope.submit = function () {
        $mdDialog.hide();
      }
    }
  }

  $onInit() {
    this.updateList();
  }

  updateList() {
    this.GlobalEventService.oem_api.index(res => {
      this.globalEvents = res;
    });
  }

  showModal($event) {
    const parent = angular.element(document.body);
    this.$mdDialog.show({
      parent: parent,
      targetEvent: $event,
      template: require('./global_event.modal.html'),
      locals: {
        text: this.text,
        occurred_at: this.occurred_at
      },
      controller: this.dialogController
    }).then(() => {
      this.GlobalEventService.oem_api.create({
        text: this.text,
        occurred_at: this.moment(this.occurred_at).add(9, 'hours')
      }, res => {
        this.occurred_at = this.moment().toDate();
        this.text = '';
        this.updateList();
      });
    });
  }
}

export default angular.module('leptonApp.oemGlobalEvent', [moment, GlobalEventService])
  .config(routing)
  .component('oemGlobalEvent', {
    template: require('./global_event.html'),
    controller: OemGlobalEventController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/oem/global_event/global_event.component.js